import React, { JSX, useEffect, useState, useRef } from 'react';
import { classNames } from 'assets/utils/helper';

type SortByProps = {
  sort: string;
  updateSort: Function;
  withOrigin: boolean;
};

const SortBy = (props: SortByProps): JSX.Element => {
  const { sort, updateSort, withOrigin } = props;
  const [sortActive, setSortActive] = useState(false);
  const container = useRef<HTMLDivElement>(null);
  const optionsMap = [
    { value: 'BEST_MATCH', label: 'Best Match' },
    { value: 'ALPHABETICAL', label: 'Alphabetically (A-Z)' },
    { value: 'REVERSE_ALPHABETICAL', label: 'Alphabetically (Z-A)' },
    { value: 'DISTANCE', label: 'Sort by Proximity', conditional: withOrigin },
  ];

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (container.current && !container.current.contains(e.target as Node)) {
        setSortActive(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="sort-box" ref={container}>
      <button
        onClick={() => setSortActive(!sortActive)}
        className={classNames(
          'btn-tertiary sort-btn',
          sortActive ? 'open' : ''
        )}
      >
        Sort Results by:{' '}
        {optionsMap.find(option => option.value === sort)?.label}
      </button>
      {sortActive && (
        <div className="sort-dropdown">
          {optionsMap.map(option => (
            <div
              className={`radio-wrapper${option.conditional === false ? ' disabled' : ''}`}
            >
              <input
                onChange={() => {
                  updateSort(option.value);
                  setSortActive(!sortActive);
                }}
                type="radio"
                id={option.value}
                checked={sort === option.value}
                name="Sort"
                disabled={option.conditional === false}
              />
              <label htmlFor={option.value}>
                <span>{option.label}</span>
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SortBy;
